import React from 'react';
import { Outlet } from 'react-router-dom';
import { LayoutStyles } from './LayoutStyles';
import Footer from '../footer/Footer';
import Header from '../header/Header';

export const Layout: React.FC = () => (
  <LayoutStyles>
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
  </LayoutStyles>
);
